"use client";

import dynamic from "next/dynamic";

const Map = dynamic(() => import("./Map").then((module) => module.Map), {
  ssr: false,
  loading: () => (
    <div
      className="min-h-[70vh] rounded-lg bg-background"
      aria-busy="true"
      aria-label="Loading map"
    />
  ),
});

export function MapClient(props) {
  return <Map {...props} />;
}
